module.exports = __webpack_public_path__ + "img/b_blue.2a3f8e06.svg";